import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AccountService } from '../../../service/account.service';

@Component({
  selector: 'app-tutorial',
  imports: [MatButtonModule, MatCardModule, MatIconModule, RouterModule],
  templateUrl: './tutorial.component.html',
  styleUrl: './tutorial.component.less'
})
export class TutorialComponent {
  accountService = inject(AccountService);
  router = inject(Router);

  ngOnInit() {
    this.accountService.account.subscribe(account => {
      if (account !== undefined && (account === null || !account.staff)) {
        this.router.navigate(['/scripts/sunsetting-info']);
      }
    });
  }
}
